import { z } from 'zod/v4-mini';

import { Schema } from '@/utils/zodUtils.ts';

export type ApiErrorData = {
  statusCode: number;
  error: string;
  data?: unknown;
};

export class ApiError extends Error {
  constructor(public readonly data: ApiErrorData) {
    super(data.error);
  }
}

export const apiErrorSchema = (statusCode: number): Schema<ApiErrorData> =>
  z.pipe(
    z.object({
      error: z.string(),
      data: z.unknown(),
    }),
    z.transform(data => ({
      ...data,
      statusCode,
    })),
  );
